import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://xtthbelvldaesfgbctso.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh0dGhiZWx2bGRhZXNmZ2JjdHNvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ3MTMzMDIsImV4cCI6MjA4MDI4OTMwMn0.byaWCloDNc-YUmy99PpVN3FhvnFphVzn1DDF087Ocw4'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// For React:
// import { supabase } from "@/integrations/supabase/client";
// For React Native:
// import { supabase } from "@/src/integrations/supabase/client";
